import React, { useState,useEffect,useCallback } from 'react';
import Button from 'carbon-components-react/lib/components/Button';
import  Automation  from 'assets/image/Create_Schedule.svg';
import i18n from "../../i18n";
import { useHistory } from 'react-router-dom';

require("./_add-new-code.scss");


const AddNewSchedule = props => {
   

  useEffect(() => {
    

  }, []);
  const ScheduleCreation = i18n.t('scheduleRecommendation.ScheduleCreation');
  const statusCheck = i18n.t('qualityCode.statusCheck');
  const buttonCheck = i18n.t('qualityCode.buttonCheck');
  const GotoScheduler = i18n.t('qualityCode.GotoScheduler');
  const history = useHistory();

  return (
      <div className="page-margin padding-top-30px">
        
        <div className="add-new-code-page-margin">
        <div className="add-new-main">
            <div className= "add-new-main-segment-image"><img src={Automation} alt="" /></div>
            <div className="add-new-main-segment">
                  <ul className="add-new-main-segment-heading">{ScheduleCreation}</ul>                 
                  <ul><Button className="add-new-main-segment-button" kind="tertiary" onClick={() => history.push('/addSchedule')} >{GotoScheduler}</Button></ul>
            </div>
         </div>
         </div>
         </div>
      );
}
export default AddNewSchedule